import { CheckboxField } from '@ipfabric/ui-components/CheckboxField/CheckboxField';
import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { TextInput } from '@ipfabric/ui-components/TextInput/TextInput';
import type { FC } from 'react';

type Props = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSearchClear: () => void;
  showUnloadedSnapshots: boolean;
  onShowUnloadedChange: (value: boolean) => void;
  unloadedCount: number;
};

export const SnapshotFilters: FC<Props> = ({
  searchValue,
  onSearchChange,
  onSearchClear,
  showUnloadedSnapshots,
  onShowUnloadedChange,
  unloadedCount,
}) => {
  return (
    <>
      <TextInput
        onChange={(e) => onSearchChange(e.target.value)}
        onClear={onSearchClear}
        placeholder='Search snapshots'
        size='default'
        startAdornment={<Icon glyph='fa-magnifying-glass' iconStyle='solid' />}
        type='text'
        value={searchValue}
        className='mt-2'
      />
      <CheckboxField
        description={`Show unloaded snapshots (${unloadedCount})`}
        onChange={onShowUnloadedChange}
        size='default'
        value={showUnloadedSnapshots}
      />
    </>
  );
};
